import { db } from '@/db/db';
import { RouteCourse, type Course } from './course';
import { DEMO_ROUTE_ID, demoRoute } from './demo';
import type { ProcessedRoute } from './model';
import { isBuiltinRouteId, loadAllBuiltinRoutes, loadBuiltinRoute } from './builtin/load';

/** Built-in routes first (newest real route, then the synthetic demo loop), then the rider's own imports. */
export async function listRoutes(): Promise<ProcessedRoute[]> {
  const own = (await db.routes.toArray()).filter((r) => !r.deleted);
  own.sort((a, b) => b.updatedAt - a.updatedAt);
  return [...(await loadAllBuiltinRoutes()), demoRoute(), ...own];
}

export async function getRoute(id: string | null | undefined): Promise<ProcessedRoute | undefined> {
  if (!id || id === DEMO_ROUTE_ID) return demoRoute();
  if (isBuiltinRouteId(id)) return loadBuiltinRoute(id);
  return db.routes.get(id);
}

/** Course for a route id (falls back to the demo loop). */
export async function getCourse(id: string | null | undefined): Promise<Course> {
  const r = (await getRoute(id)) ?? demoRoute();
  return new RouteCourse(r);
}

export async function defaultCourse(): Promise<Course> {
  return new RouteCourse(demoRoute());
}

export async function deleteRoute(id: string): Promise<void> {
  if (isBuiltinRouteId(id)) return;
  const r = await db.routes.get(id);
  if (r) await db.routes.put({ ...r, deleted: true, updatedAt: Date.now() });
}
